import React from 'react';

const CentrifugalPump2Icon = ({
  width = 64,
  height = 64,
  className = '',
  startColor = '#373737',
  midColor = '#EBEBEB',
  endColor = '#373737'
}) => {
  const uid = React.useId ? React.useId() : 'sc' + Math.random().toString(36).substr(2, 9);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 112.5 47.182"
      className={className}
    >

<g id={`${uid}_1`}>
	<linearGradient id={`${uid}_2`} gradientUnits="userSpaceOnUse" x1="109.6807" y1="44.4795" x2="109.6807" y2="13.6255">
		<stop offset="0" style={{stopColor: `${startColor}`}} />
		<stop offset="0.45" style={{stopColor: `${midColor}`}} />
		<stop offset="0.55" style={{stopColor: `${midColor}`}} />
		<stop offset="0.76" style={{stopColor: `${endColor}`}} />
		<stop offset="0.77" style={{stopColor: `${endColor}`}} />
		<stop offset="1" style={{stopColor: `${startColor}`}} />
	</linearGradient>
	<path fill={`url(#${uid}_2)`} d="M108.217,13.625h2.928v30.854h-2.928V13.625" />
</g>
<g id={`${uid}_3`}>
	<linearGradient id={`${uid}_4`} gradientUnits="userSpaceOnUse" x1="87.3857" y1="45.8311" x2="87.3857" y2="12.2744">
		<stop offset="0" style={{stopColor: `${startColor}`}} />
		<stop offset="0.45" style={{stopColor: `${midColor}`}} />
		<stop offset="0.55" style={{stopColor: `${midColor}`}} />
		<stop offset="0.76" style={{stopColor: `${endColor}`}} />
		<stop offset="0.77" style={{stopColor: `${endColor}`}} />
		<stop offset="1" style={{stopColor: `${startColor}`}} />
	</linearGradient>
	<path fill={`url(#${uid}_4)`} d="M85.922,12.274h2.928v33.557h-2.928V12.274" />
	<linearGradient id={`${uid}_5`} gradientUnits="userSpaceOnUse" x1="44.2578" y1="45.6045" x2="44.2578" y2="12.2744">
		<stop offset="0" style={{stopColor: `${startColor}`}} />
		<stop offset="0.45" style={{stopColor: `${midColor}`}} />
		<stop offset="0.55" style={{stopColor: `${midColor}`}} />
		<stop offset="0.76" style={{stopColor: `${endColor}`}} />
		<stop offset="0.77" style={{stopColor: `${endColor}`}} />
		<stop offset="1" style={{stopColor: `${startColor}`}} />
	</linearGradient>
	<path fill={`url(#${uid}_5)`} d="M10.926,45.604h55.626l11.036-2.702V14.977l-11.036-2.703H10.926V45.604z" />
	<path fill={`${startColor}`} d="M10.926,45.612h55.626v1.562H10.926V45.612z" />
	
		<radialGradient id={`${uid}_6`} cx="-4.2803" cy="55.6836" r="5.3069" gradientTransform="matrix(0 -3.069 3.2232 0 -176.714 15.116)" gradientUnits="userSpaceOnUse">
		<stop offset="0" style={{stopColor: `${midColor}`}} />
		<stop offset="0.14" style={{stopColor: `${midColor}`}} />
		<stop offset="0.4" style={{stopColor: `${midColor}`}} />
		<stop offset="0.75" style={{stopColor: `${endColor}`}} />
		<stop offset="1" style={{stopColor: `${startColor}`}} />
	</radialGradient>
	<path fill={`url(#${uid}_6)`} d="M10.926,45.604c-9.259-1.815-10.928-5.22-10.928-16.838c0-11.575,2.169-14.575,10.928-16.493" />
	<linearGradient id={`${uid}_7`} gradientUnits="userSpaceOnUse" x1="81.7559" y1="41.5518" x2="81.7559" y2="16.5532">
		<stop offset="0" style={{stopColor: `${startColor}`}} />
		<stop offset="0.45" style={{stopColor: `${midColor}`}} />
		<stop offset="0.55" style={{stopColor: `${midColor}`}} />
		<stop offset="0.76" style={{stopColor: `${endColor}`}} />
		<stop offset="0.77" style={{stopColor: `${endColor}`}} />
		<stop offset="1" style={{stopColor: `${startColor}`}} />
	</linearGradient>
	<path fill={`url(#${uid}_7)`} d="M77.589,16.553h8.333v24.999h-8.333V16.553z" />
</g>
<g id={`${uid}_8`}>
	<path fill={`${startColor}`} d="M22.187,12.274h41.665V40.2H22.187V12.274z" />
	<path fill={`${startColor}`} d="M77.589,38.849h8.333v2.703h-8.333V38.849z" />
	<path fill={`${startColor}`} d="M77.589,30.966h8.333v4.055h-8.333V30.966z" />
	<path fill={`${startColor}`} d="M77.589,23.084h8.333v4.054h-8.333V23.084z" />
	<path fill={`${startColor}`} d="M77.589,16.553h8.333v2.703h-8.333V16.553z" />
</g>
<g id={`${uid}_9`}>
	<path fill={`${endColor}`} d="M16.557,30.517h48.42v2.702h-48.42V30.517z" />
	<path fill={`${endColor}`} d="M16.557,35.921h48.42v2.928h-48.42V35.921z" />
	<path fill={`${midColor}`} d="M16.557,19.255h48.42v2.928h-48.42V19.255z" />
	<path fill={`${midColor}`} d="M16.557,24.886h48.42v2.703h-48.42V24.886z" />
	<path fill={`${midColor}`} d="M16.557,13.625h48.42v2.928h-48.42V13.625z" />
	<path fill={`${midColor}`} d="M16.557,10.923h48.42v1.351h-48.42V10.923z" />
</g>
<g id={`${uid}_10`}>
	<linearGradient id={`${uid}_11`} gradientUnits="userSpaceOnUse" x1="88.8496" y1="9.5713" x2="102.5869" y2="9.5713">
		<stop offset="0" style={{stopColor: `${startColor}`}} />
		<stop offset="0.45" style={{stopColor: `${midColor}`}} />
		<stop offset="0.55" style={{stopColor: `${midColor}`}} />
		<stop offset="0.76" style={{stopColor: `${endColor}`}} />
		<stop offset="0.77" style={{stopColor: `${endColor}`}} />
		<stop offset="1" style={{stopColor: `${startColor}`}} />
	</linearGradient>
	<path fill={`url(#${uid}_11)`} d="M91.552,16.553L88.85,2.59h13.737l-2.702,13.963H91.552z" />
</g>
<g id={`${uid}_12`}>
	<linearGradient id={`${uid}_13`} gradientUnits="userSpaceOnUse" x1="78.9395" y1="1.2949" x2="112.4961" y2="1.2949">
		<stop offset="0" style={{stopColor: `${startColor}`}} />
		<stop offset="0.45" style={{stopColor: `${midColor}`}} />
		<stop offset="0.55" style={{stopColor: `${midColor}`}} />
		<stop offset="0.76" style={{stopColor: `${endColor}`}} />
		<stop offset="0.77" style={{stopColor: `${endColor}`}} />
		<stop offset="1" style={{stopColor: `${startColor}`}} />
	</linearGradient>
	<path fill={`url(#${uid}_13)`} d="M78.939,2.59V0h33.557v2.59H78.939" />
</g>
<g id={`${uid}_14`}>
	<linearGradient id={`${uid}_15`} gradientUnits="userSpaceOnUse" x1="90.3262" y1="41.5518" x2="90.3262" y2="16.5532">
		<stop offset="0" style={{stopColor: `${startColor}`}} />
		<stop offset="0.45" style={{stopColor: `${midColor}`}} />
		<stop offset="0.55" style={{stopColor: `${midColor}`}} />
		<stop offset="0.76" style={{stopColor: `${endColor}`}} />
		<stop offset="0.77" style={{stopColor: `${endColor}`}} />
		<stop offset="1" style={{stopColor: `${startColor}`}} />
	</linearGradient>
	<path fill={`url(#${uid}_15)`} d="M88.85,16.553h2.952v24.999H88.85V16.553" />
	<linearGradient id={`${uid}_16`} gradientUnits="userSpaceOnUse" x1="102.5859" y1="41.5518" x2="102.5859" y2="16.5532">
		<stop offset="0" style={{stopColor: `${startColor}`}} />
		<stop offset="0.45" style={{stopColor: `${midColor}`}} />
		<stop offset="0.55" style={{stopColor: `${midColor}`}} />
		<stop offset="0.76" style={{stopColor: `${endColor}`}} />
		<stop offset="0.77" style={{stopColor: `${endColor}`}} />
		<stop offset="1" style={{stopColor: `${startColor}`}} />
	</linearGradient>
	<polygon fill={`url(#${uid}_16)`} points="99.771,16.553 99.771,41.552 105.401,38.849 105.401,19.255  " />
	<path fill="none" stroke={`${startColor}`} strokeWidth="0.25" d="M105.515,38.849V19.255" />
	<linearGradient id={`${uid}_17`} gradientUnits="userSpaceOnUse" x1="95.7188" y1="47.1816" x2="95.7188" y2="10.1255">
		<stop offset="0" style={{stopColor: `${startColor}`}} />
		<stop offset="0.45" style={{stopColor: `${midColor}`}} />
		<stop offset="0.55" style={{stopColor: `${midColor}`}} />
		<stop offset="0.76" style={{stopColor: `${endColor}`}} />
		<stop offset="0.77" style={{stopColor: `${endColor}`}} />
		<stop offset="1" style={{stopColor: `${startColor}`}} />
	</linearGradient>
	<path fill={`url(#${uid}_17)`} d="M91.552,10.125h8.333v37.057h-8.333V10.125z" />
	<linearGradient id={`${uid}_18`} gradientUnits="userSpaceOnUse" x1="106.6504" y1="38.8486" x2="106.6504" y2="19.2559">
		<stop offset="0" style={{stopColor: `${startColor}`}} />
		<stop offset="0.45" style={{stopColor: `${midColor}`}} />
		<stop offset="0.55" style={{stopColor: `${midColor}`}} />
		<stop offset="0.76" style={{stopColor: `${endColor}`}} />
		<stop offset="0.77" style={{stopColor: `${endColor}`}} />
		<stop offset="1" style={{stopColor: `${startColor}`}} />
	</linearGradient>
	<rect x="105.084" y="19.255" fill={`url(#${uid}_18)`} width="3.133" height="19.593" />
</g>
<g id={`${uid}_19`}>
	<path fill={`${endColor}`} d="M19.259,26.237h22.296v20.944H19.259V26.237z" />
	<path fill="none" stroke={`${midColor}`} strokeWidth="0.25" d="M22.187,44.479V29.165h15.314" />
	<path fill={`${startColor}`} d="M41.555,26.237h1.351v19.375h-1.351V26.237z" />
</g>
<g id={`${uid}_20`}>
	<circle fill={`${endColor}`} cx="31.758" cy="36.034" r="4.167" />
</g>
    </svg>
  );
};

export default CentrifugalPump2Icon;
